// src/features/dashboard/accesos/hooks.js
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "lib/api";
import { useDashboardSettings } from "../settings/store";

const ACCESOS_PREFIX = ["dashboard", "accesos"];
const JSON_HEADERS = { "Content-Type": "application/json" };

const dashboardAccesosKeys = {
  accesos(periodoId) {
    return ["dashboard", "accesos", { periodoId }];
  },
  instructoresSearch(q) {
    return ["dashboard", "accesos", "instructores", { q }];
  },
};

function invalidateAccesos(qc) {
  qc.invalidateQueries({ queryKey: ACCESOS_PREFIX });
}

export function useDashboardAccesos(enabled = true) {
  const s = useDashboardSettings();
  return useQuery({
    queryKey: dashboardAccesosKeys.accesos(s.periodoId),
    queryFn: () => api("/dashboard/club/accesos", {}, { periodoId: s.periodoId }),
    enabled: enabled && !!s.periodoId,
    staleTime: 20_000,
  });
}

export function useSearchDashboardInstructores(q, enabled = true) {
  const s = useDashboardSettings();
  const query = String(q || "").trim();
  return useQuery({
    queryKey: dashboardAccesosKeys.instructoresSearch(query),
    queryFn: () => api(`/dashboard/club/accesos/instructores?q=${encodeURIComponent(query)}`, {}, { periodoId: s.periodoId }),
    enabled: enabled && !!s.periodoId && query.length >= 2,
    staleTime: 10_000,
  });
}

export function useSetDashboardAccesosForUsuario() {
  const s = useDashboardSettings();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ usuarioId, payload }) =>
      api(`/dashboard/club/accesos/usuarios/${usuarioId}`, { method: "PUT", body: JSON.stringify(payload), headers: JSON_HEADERS }, { periodoId: s.periodoId }),
    onSuccess: () => invalidateAccesos(qc),
  });
}

export function useClearDashboardAccesosForUsuario() {
  const s = useDashboardSettings();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (usuarioId) => api(`/dashboard/club/accesos/usuarios/${usuarioId}`, { method: "DELETE" }, { periodoId: s.periodoId }),
    onSuccess: () => invalidateAccesos(qc),
  });
}

